import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { BaseIcon } from '../../../components/base-icon.mjs';

const SvgScaleBalanced = forwardRef((props, ref) => /* @__PURE__ */ jsx(BaseIcon, { fill: "currentColor", ref, ...props, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    d: "M12 4a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-2.952.462c-.483.19-.868.432-1.19.71-.363.315-.638.677-.831.93l-.106.14c-.21.268-.36.418-.574.527C6.125 6.883 5.74 7 5 7a1 1 0 0 0 0 2q.545 0 1-.067v.41l-1.864 4.2a1.774 1.774 0 0 0 .821 2.255c.255.133.538.202.825.202h2.436a1.786 1.786 0 0 0 1.768-1.558 1.8 1.8 0 0 0-.122-.899L8 9.343V8.028c.2-.188.36-.38.495-.553q.093-.118.168-.217c.185-.24.311-.406.503-.571a2 2 0 0 1 .24-.177A3 3 0 0 0 11 7.829V20H5.5a1 1 0 1 0 0 2h13a1 1 0 1 0 0-2H13V7.83a3 3 0 0 0 1.63-1.387c.206.091.373.19.514.29.31.219.532.465.811.78l.025.027.02.023v1.78l-1.864 4.2a1.774 1.774 0 0 0 .821 2.255c.255.133.538.202.825.202h2.436a1.785 1.785 0 0 0 1.768-1.558 1.8 1.8 0 0 0-.122-.899L18 9.343v-.452q.451.108 1 .109a1 1 0 1 0 0-2c-.48 0-.731-.098-.899-.2-.2-.12-.363-.293-.651-.617l-.024-.026c-.267-.3-.622-.7-1.127-1.057a5.2 5.2 0 0 0-1.355-.678 3.001 3.001 0 0 0-5.896.04",
    clipRule: "evenodd"
  }
) }));

export { SvgScaleBalanced as default };
//# sourceMappingURL=scale-balanced.mjs.map
